import { render, staticRenderFns } from "./ProfileChangePasswordModal.vue?vue&type=template&id=4c5c32f6&"
import script from "./ProfileChangePasswordModal.vue?vue&type=script&lang=js&"
export * from "./ProfileChangePasswordModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports